import Vue from 'vue';
import catalogueTransformer from '../../transformers/catalogue';

const success = (data, resolve) => {
  resolve(catalogueTransformer.fetch(data));
};

const failed = (errors, reject) => {
  reject(errors);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: '/catalogues',
        data,
        method: 'post',
      })
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/sendCatalogue.js